<template>
  <b-overlay
      :show="$store.getters['PTC_PermissaoAcessoClient/getIsLoading']"
  >
    <b-row>
      <b-col>
        <b-button
            variant="gradient-primary"
            :to="{ name: 'permissao-acesso'}"
        >
          <feather-icon
              icon="ArrowLeftIcon"
              class="mr-50"
          />
          <span class="align-middle">Voltar</span>
        </b-button>
      </b-col>
    </b-row>

    <b-card class="position-static mt-2 mb-4">
      <validation-observer ref="simpleRules">
      <b-form @submit.prevent="createUsuario" ref="reset">
        <b-row>
          <b-col cols="12">
            <b-form-group
                label="Nome"
                label-for="hi-first-name"
                label-cols-md="2"
                label-size="lg"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Nome"
                  rules="required"
              >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fi fi-sr-user"></i>
                </b-input-group-prepend>
                <b-form-input
                    id="hi-first-name"
                    placeholder="Nome do usuário"
                    v-model="form.usuario_nome"
                />
              </b-input-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="Email"
                label-for="hi-email"
                label-cols-md="2"
                label-size="lg"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fi fi-sr-envelope"></i>
                </b-input-group-prepend>
                <b-form-input
                    id="hi-email"
                    type="email"
                    placeholder="Email do usuário"
                    v-model="form.usuario_email"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
                label="Senha"
                label-for="hi-password"
                label-cols-md="2"
                label-size="lg"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fi fi-sr-lock"></i>
                </b-input-group-prepend>
                <b-form-input
                    id="hi-password"
                    type="password"
                    placeholder="Senha do usuário"
                    v-model="form.usuario_senha"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" >
            <b-form-group
                label="Sexo"
                label-for="hi-sexo"
                label-cols-md="4"
                label-size="lg"
            >
                <v-select
                    style="margin-left: 3px;"
                    v-model="form.usuario_sexo"
                    placeholder="Selecione o sexo"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="option"
                />
            </b-form-group>
          </b-col>

          <!-- <div>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-home"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Dashboard</strong>
                        <small class="text-muted ">Área de conhecimento para o usuário</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_Dashboard"
                      v-model="form.permission.Acesso_Dashboard"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-clipboard-list-check"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Pedidos</strong>
                        <small class="text-muted ">Área de Pedidos realizados</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_Pedidos"
                       v-model="form.permission.Acesso_Pedidos"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-memo"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Notas Fiscais</strong>
                        <small class="text-muted ">Área de visualização das notas fiscais</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_NotaFiscal"
                        v-model="form.permission.Acesso_NotaFiscal"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-rectangle-barcode"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Boletos</strong>
                        <small class="text-muted ">Área de visualização, impressão e pagamento de boletos</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_Boleto"
                       v-model="form.permission.Acesso_Boleto"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-box-open"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Produtos</strong>
                        <small class="text-muted ">Área de visualização, Produtos</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_Produtos"
                       v-model="form.permission.Acesso_Produtos"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-users-gear"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Visualização/Edição dos dados do cliente</strong>
                        <small class="text-muted ">Área de visualização e edição de todos os dados do cliente</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_CadastroCliente"
                       v-model="form.permission.Acesso_CadastroCliente"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" md="11">
                  <ul class="colors-list list-unstyled ">
                    <li class="d-flex align-items-center mb-2 col-md-4">
                      <i class="fi fi-sr-user-lock"></i>
                      <div class="ml-2">
                        <strong class="mb-6 d-block">Permissões e Cadastro de usuários</strong>
                        <small class="text-muted ">Área de visualização e edição de todos os usuários pertencentes</small>
                      </div>
                    </li>
                  </ul>
                </b-col>
                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-end">
                  <b-form-checkbox
                      :checked="form.permission.Acesso_Permissao"
                      v-model="form.permission.Acesso_Permissao"
                      class="custom-control-success"
                      name="check-button"
                      switch
                  />
                </b-col>
              </b-row>
            </b-col>
          </div> -->
          <!-- submit and reset -->
          <b-col>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
            >
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, email, confirmed, password,
} from '@validations';
import PTC_PermissaoAcessosService from '@/services/PTC/PTC_PermissaoAcesso.service';

const PTC_PermissaoAcessoClient = new PTC_PermissaoAcessosService();

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormCheckboxGroup,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isBusy: false,
      form: {
        usuario_nome: '',
        usuario_email: '',
        usuario_senha: '',
        usuario_sexo: '',
        permission: {
          Acesso_Dashboard: false,
          Acesso_Permissao: false,
          Acesso_Pedidos: false,
          Acesso_NotaFiscal: false,
          Acesso_Boleto: false,
          Acesso_Produtos: false,
          Acesso_CadastroCliente: false,
        },
      },
      option: ['Masculino', 'Feminino'],
      required,
      email,
      confirmed,
      password,
    };
  },
  methods: {
    async createUsuario() {
      await PTC_PermissaoAcessoClient.cadastrarUsuario(this.form);
      this.$router.push({ name: 'permissao-acesso' });
      this.resetForm();
    },

    async resetForm() {
      this.form = {
        usuario_nome: '',
        usuario_email: '',
        usuario_senha: '',
        usuario_sexo: '',
        permission: {
          Acesso_Dashboard: false,
          Acesso_Permissao: false,
          Acesso_Pedidos: false,
          Acesso_NotaFiscal: false,
          Acesso_Boleto: false,
          Acesso_Produtos: false,
          Acesso_CadastroCliente: false,
        },
      };
    },

  },
};
</script>
<style scoped>
@import url('https://cdn-uicons.flaticon.com/2.0.0/uicons-solid-rounded/css/uicons-solid-rounded.css');

.fi-sr-user-lock,
.fi-sr-users-gear,
.fi-sr-home,
.fi-sr-clipboard-list-check,
.fi-sr-memo,
.fi-sr-box-open,
.fi-sr-rectangle-barcode {
  font-size: 30px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
